import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    versionLabel: undefined,
};

export default createReducer(initial, {
    [actions.setVersionLabel]: (state, action) => {
        return { ...state, versionLabel: action.payload };
    },
});
